import _classCallCheck from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { ParticlesBounceFactor } from "./ParticlesBounceFactor";
export var ParticlesBounce = /*#__PURE__*/function () {
  function ParticlesBounce() {
    _classCallCheck(this, ParticlesBounce);

    this.horizontal = new ParticlesBounceFactor();
    this.vertical = new ParticlesBounceFactor();
  }

  _createClass(ParticlesBounce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      this.horizontal.load(data.horizontal);
      this.vertical.load(data.vertical);
    }
  }]);

  return ParticlesBounce;
}();